import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
// import { ProfitLossStatementComponent } from './profit-loss-statement/profit-loss-statement.component';



@NgModule({
  declarations: [
    
  ],
  imports: [
    CommonModule
  ]
})
export class ReportsModule { }
